module.exports = function() {
  return new Worker(__webpack_public_path__ + "ae23e407f6738455b92f.worker.js");
};